export const getDefaultBudgetMarks = (upTo, k, over) => ({
  0: '',
  1: `${upTo} 25${k}`,
  2: `25-50${k}`,
  3: `50-100${k}`,
  4: `100-200${k}`,
  5: `${over} 200${k}`,
});

export const getDefaultTicketsMarks = (upTo, tickets, over) => ({
  0: '',
  1: `${upTo} 50 ${tickets}`,
  2: `50-250`,
  3: `250-500`,
  4: `500-1000`,
  5: `${over} 1000 ${tickets}`,
});

export const getDefaultDurationMarks = (month, months, year, years) => ({
  0: '',
  1: `1 ${month}`,
  2: '',
  3: '',
  4: '',
  5: '',
  6: `6 ${months}`,
  7: '',
  8: '',
  9: '',
  10: '',
  11: '',
  12: `1 ${year}`,
  13: '',
  14: '',
  15: '',
  16: '',
  17: '',
  18: `1.5 ${years}`,
  19: '',
  20: '',
  21: '',
  22: '',
  23: '',
  24: `2+ ${years}`,
});
